import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    programs2 ({ commit }, params) {
      return axiosInstance.get('/api/v1/programs2', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
